import {useEffect} from 'react';

import {useLocation} from 'react-router-dom';

interface Props {
  smoothScroll?: boolean;
}

const ScrollToTop = ({smoothScroll = false}: Props) => {
  const location = useLocation();
  useEffect(() => {
    if (!window.location.href.includes('#')) {
      window.scrollTo({top: 0, left: 0, behavior: smoothScroll ? 'smooth' : undefined});
    }
  }, [location, smoothScroll]);
  return null;
};

export default ScrollToTop;
